import { createAsyncThunk } from '@reduxjs/toolkit';
import { postCreateTasksFromAssignments } from 'scenes/Timelines/services/postCreateTasksFromAssignments.service';

export const createTasksFromAssignments = createAsyncThunk(
  'timelines/createTasksFromAssignments',
  async ({ projectId, timelineId }) => {
    const response = await postCreateTasksFromAssignments(
      projectId,
      timelineId
    );
    return response;
  }
);
